export type JsonValue =
  | string
  | number
  | boolean
  | null
  | JsonValue[]
  | { [key: string]: JsonValue };


export interface EmailQueue {
  emailQueueId: number;
  campaignId: number;
  [key: string]: unknown;
}

export class Campaign {
  campaignId: number;
  numberOfEmails: number;
  timeBetweenEmails: number;
  sendGridTemplateIdSequence: JsonValue;
  killSequenceOnResponse: boolean;
  emailQueues: EmailQueue[];

  constructor(data: {
    campaignId: number;
    numberOfEmails: number;
    timeBetweenEmails: number;
    sendGridTemplateIdSequence: JsonValue;
    killSequenceOnResponse: boolean;
    emailQueues?: EmailQueue[];
  }) {
    this.campaignId = data.campaignId;
    this.numberOfEmails = data.numberOfEmails;
    this.timeBetweenEmails = data.timeBetweenEmails;
    this.sendGridTemplateIdSequence = data.sendGridTemplateIdSequence;
    this.killSequenceOnResponse = data.killSequenceOnResponse;
    this.emailQueues = data.emailQueues ?? [];
  }

  static fromJSON(json: any): Campaign {
    return new Campaign({
      campaignId: json.campaignId,
      numberOfEmails: json.numberOfEmails,
      timeBetweenEmails: json.timeBetweenEmails,
      sendGridTemplateIdSequence: json.sendGridTemplateIdSequence,
      killSequenceOnResponse: json.killSequenceOnResponse,
      emailQueues: json.emailQueues ?? [],
    });
  }
}

export class CampaignCreateDto {
  numberOfEmails: number;
  timeBetweenEmails: number;
  sendGridTemplateIdSequence: JsonValue;
  killSequenceOnResponse: boolean;

  constructor(data: {
    numberOfEmails: number;
    timeBetweenEmails: number;
    sendGridTemplateIdSequence: JsonValue;
    killSequenceOnResponse: boolean;
  }) {
    this.numberOfEmails = data.numberOfEmails;
    this.timeBetweenEmails = data.timeBetweenEmails;
    this.sendGridTemplateIdSequence = data.sendGridTemplateIdSequence;
    this.killSequenceOnResponse = data.killSequenceOnResponse;
  }
}

export class CampaignUpdateDto {
  numberOfEmails?: number;
  timeBetweenEmails?: number;
  sendGridTemplateIdSequence?: JsonValue;
  killSequenceOnResponse?: boolean;

  constructor(data: {
    numberOfEmails?: number;
    timeBetweenEmails?: number;
    sendGridTemplateIdSequence?: JsonValue;
    killSequenceOnResponse?: boolean;
  } = {}) {
    this.numberOfEmails = data.numberOfEmails;
    this.timeBetweenEmails = data.timeBetweenEmails;
    this.sendGridTemplateIdSequence = data.sendGridTemplateIdSequence;
    this.killSequenceOnResponse = data.killSequenceOnResponse;
  }
}